import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getEstablishmentTypeList,
	addNewEstablishmentType,
	updateEstablishmentType,
	deleteEstablishmentType,
	getEstablishmentType,
	getEstablishmentTypeCodes,
} from '../establishmentType/thunk';

export const initialState = {
	itemEstablishmentTypeList: [],
	itemEstablishmentTypeDetail: null,
	isEstablishmentTypeLoading: false,
	isEstablishmentTypeSuccess: false,

	productiveCycleActiveDetail: null,

	establishmentTypeList: [],
	establishmentTypeListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const EstablishmentTypeSlice = createSlice({
	name: 'EstablishmentTypes',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getEstablishmentType.fulfilled, (state, action) => {
			state.isEstablishmentTypeLoading = false;
			state.isEstablishmentTypeSuccess = true;
			state.itemEstablishmentTypeDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getEstablishmentType.pending, state => {
			state.isEstablishmentTypeLoading = true;
			state.isEstablishmentTypeSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getEstablishmentType.rejected, (state, action) => {
			state.isEstablishmentTypeLoading = false;
			state.isEstablishmentTypeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getEstablishmentTypeList.pending, state => {
			state.isEstablishmentTypeSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getEstablishmentTypeList.fulfilled, (state, action) => {
			state.itemEstablishmentTypeList = action.payload;
			state.establishmentTypeList = action.payload;
			state.isLoadingList = false;
			state.isEstablishmentTypeSuccess = true;

			let establishmentTypeListSelect = [];
			action.payload.map(item =>
				establishmentTypeListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.establishmentTypeListSelect = establishmentTypeListSelect;
		});
		builder.addCase(getEstablishmentTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isEstablishmentTypeSuccess = true;
		});
		builder.addCase(addNewEstablishmentType.fulfilled, (state, action) => {
			state.itemEstablishmentTypeList.push(action.payload);
			state.establishmentTypeList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewEstablishmentType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewEstablishmentType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateEstablishmentType.fulfilled, (state, action) => {
			state.itemEstablishmentTypeList = state.itemEstablishmentTypeList.map(establishmentType =>
				establishmentType.establishmentTypename === action.payload.old_establishmentType
					? { ...establishmentType, ...action.payload.updated_establishmentType }
					: establishmentType
			);
			state.establishmentTypeList = state.establishmentTypeList.map(establishmentType =>
				establishmentType._id.toString() === action.payload._id.toString()
					? { ...establishmentType, ...action.payload }
					: establishmentType
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateEstablishmentType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateEstablishmentType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteEstablishmentType.fulfilled, (state, action) => {
			state.itemEstablishmentTypeList = current(state.itemEstablishmentTypeList).filter(
				item => item._id !== action.payload._id
			);
			state.establishmentTypeList = current(state.establishmentTypeList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteEstablishmentType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteEstablishmentType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});


		

		
		builder.addCase(getEstablishmentTypeCodes.fulfilled, (state, action) => {
			state.isEstablishmentTypeLoading = false;
			state.isEstablishmentTypeSuccess = true;
			state.itemEstablishmentTypeDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getEstablishmentTypeCodes.pending, state => {
			state.isEstablishmentTypeLoading = true;
			state.isEstablishmentTypeSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getEstablishmentTypeCodes.rejected, (state, action) => {
			state.isEstablishmentTypeLoading = false;
			state.isEstablishmentTypeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

	},
});

export const { setRequireCloseModal } = EstablishmentTypeSlice.actions;

export default EstablishmentTypeSlice.reducer;
